import React, { useState } from 'react';
import { surpriseMe } from '../lib/generateItinerary';

export default function SpinWheel({ onClose, onSurprise, onTweak }) {
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(null);

  const spin = () => {
    setSpinning(true);
    setResult(null);
    // Show a quick "spinning" animation, then reveal a random preset
    setTimeout(() => {
      setResult(surpriseMe());
      setSpinning(false);
    }, 900);
  };

  return (
    <div
      data-testid="spin-wheel-modal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 text-center" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-2xl font-bold text-gray-900">🎡 Alberta Surprise Mode</h3>
          <button data-testid="close-spin-wheel" onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl" aria-label="Close">×</button>
        </div>
        <p className="text-sm text-gray-500 mb-5">Let Culinera pick a random Alberta food adventure for you. Spin to see what fate has in store.</p>

        <div
          className={`mx-auto w-40 h-40 rounded-full border-[10px] border-teal-600 flex items-center justify-center text-5xl mb-4 ${spinning ? 'animate-spin' : ''}`}
          style={{ borderTopColor: '#a855f7', borderRightColor: '#06b6d4' }}
          aria-hidden="true"
        >
          🍴
        </div>

        {result && !spinning && (
          <div data-testid="spin-result" className="bg-teal-50 border border-teal-200 rounded-lg p-4 mb-4 text-left">
            <div className="text-xs uppercase tracking-wide text-teal-700 font-semibold mb-1">Your random trip</div>
            <div className="text-lg font-bold text-gray-900 mb-1">{result.tripDuration} in {result.startingLocation}</div>
            <div className="text-sm text-gray-700">Budget: {result.budgetRange} · Focus: {result.cuisineTypes.join(', ') || 'Chef\'s choice'}</div>
          </div>
        )}

        {!result && (
          <button
            data-testid="spin-btn"
            onClick={spin}
            disabled={spinning}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-3 rounded-lg font-bold hover:opacity-90 disabled:opacity-60 transition-opacity"
          >{spinning ? 'Spinning…' : '🎲 Spin the Wheel'}</button>
        )}

        {result && (
          <div className="flex flex-col sm:flex-row gap-2">
            <button
              data-testid="surprise-me-btn"
              onClick={() => onSurprise?.(result)}
              className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-3 rounded-lg font-bold hover:opacity-90"
            >✨ Surprise me — show it!</button>
            <button
              data-testid="tweak-first-btn"
              onClick={() => onTweak?.(result)}
              className="flex-1 border border-teal-600 text-teal-700 px-4 py-3 rounded-lg font-semibold hover:bg-teal-50"
            >🛠 Tweak first</button>
          </div>
        )}

        {result && !spinning && (
          <button
            data-testid="respin-btn"
            onClick={spin}
            className="mt-3 text-sm text-gray-500 hover:text-gray-800"
          >↻ Spin again</button>
        )}
      </div>
    </div>
  );
}
